Filter = App.loadClass 'core::Angular/ReportFilters/Filter'

class exports.Sidebar

    constructor: (definitions = []) ->
        @recent_fetch_url = null
        @groups = []

        # list of groups, used for displaying filters
        for group in definitions
            @importGroup group


    ###
    Imports a new filter group and it's child filters
    ###
    importGroup: (group) =>
        filters = []

        # Create filters
        for f in group.filters
            filters.push new Filter(this, f)


        # Define some required attributes
        group.filters = filters
        group.visible = true

        if not group.display_name?
            group.display_name = group.name

        # Add group
        @groups.push group


    ###
    Removes a filter group from the sidebar
    ###
    removeGroup: (name) =>
        if not @groups?
            return false

        _.remove @groups (grp) =>
            return grp.name is name

        return true


    ###
    Hide a filter group in the sidebar
    ###
    hideGroup: (name) =>
        if not @groups?
            return false

        group = _.find @groups, { 'name': name }
        group.visible = false

        return true

    ###
    Show a filter group in the sidebar
    ###
    showGroup: (name) =>
        if not @groups?
            return false

        group = _.find @groups, { 'name': name }
        group.visible = true

        return true

    ###
    Disable a filter group in the sidebar
        NB. Disabling a filter also hides it
    ###
    disableGroup: (name) =>
        @hideGroup(name)

        group = _.find @groups, { 'name': name }

        if group?
            _.each group.filters, (fltr) =>
                fltr.disableFilter()

    ###
    Enable a filter group in the sidebar
        NB. Enabling a filter also shows it
    ###
    enableGroup: (name) =>
        @showGroup(name)

        group = _.find @groups, { 'name': name }

        if group?
            _.each group.filters, (fltr) =>
                fltr.enableFilter()

    ###
    Assign a new display name to filter group
    ###
    assignGroupName: (old_name, new_name) =>
        if not @groups?
            return false

        group = _.find @groups, { 'name': old_name }
        group.display_name = new_name

        return true

    # ###
    # populate Sidebar with filter options from the backend
    # ###
    populateSidebar: (data, cb = null) =>
        for filter, values of data
            f = @findInGroup filter
            if f isnt false
                f.populateValues values

        if cb?
            cb()


    ###
    Shortcut for finding a filter without knowing which group
    it belongs to
    ###
    findInGroup: (filter_name, cut = false) =>
        if not @groups?
            return false

        # find group that has a filter by this name
        for group in @groups
            filter = _.find group.filters, { 'name': filter_name }
            if filter?
                if cut
                    group.filters = _.remove group.filters, (fltr) =>
                        return fltr.name = filter_name
                return filter

        return false

    ###
    Remove all selected values from filters that depend on given
    ###
    clearFiltersBelow: (filter) =>
        remove = false
        for g in @groups
            for f in g.filters
                if filter.name is f.name
                    remove = true
                    continue

                if f.deletable and
                    remove and
                    f.control_type not in ['range', 'datepicker', 'date_range']
                        f.selected_values = []


    ###
    Converts our structure into a nicely passable format for
    both fetching new filters and for running report queries
    Inactive querys need to be included sent when computing filters
    but not when computing report or excel exports
    ###
    jsonize: (includeInactive = false) =>
        arr = {}
        for g in @groups
            for f in g.filters
                if f.enabled
                    vals = []

                    if f.control_type is 'range'
                        vals =
                            key:
                                min: f.low_range
                                max: f.high_range

                    else if f.control_type is 'date_range'
                        start = f.daterange.startDate
                        end = f.daterange.endDate
                        vals =
                            key:
                                start: if start? then start.format() else null
                                end: if end? then end.format() else null
                    else
                        for sv in f.selected_values
                            if includeInactive or sv.isSelectedInParent()
                                key = sv.key
                                if typeof key is 'object'
                                    key = JSON.stringify key
                                vals.push
                                    key: encodeURIComponent(key)
                                    value: encodeURIComponent(sv.value)

                    arr[f.name] = vals

        return { filters: arr }


    clearFilters: () =>
        for fg in @groups
            for f in fg.filters
                if f.deletable
                    f.selected_values = []
                    f.low_range = ''
                    f.high_range = ''
                    f.daterange =
                        startDate: null
                        endDate: null


    ###
    Move a filter from one group to another
    filter: name of filter to move
    to:     name of group to move filter to
    after:  name of filter before which the moved filter shall be put
            if after is null then the filter will be put at the top of the group
    returns:  true if filter was successfully moved
    ###
    moveFilter: (filter_name, to_group, before = null) =>
        # cut the filter out
        filter = @findInGroup(filter_name, true)

        # if the filter was not found return
        if not filter
            return false

        # find group
        group = _.find @groups, { 'name': to_group }

        # paste the filter back in
        if before?
            for f, index in group.filters
                if f.name is before
                    g.filters.splice(index, 0, filter)
        else
            group.filters.unshift filter

        return true


    ###
    Returns original filter structure (aka what is seen in the report fluent filter)
    ignoredFltrs: array of filter names to exclude
    ignoredGrps: array of group names to exclude
    ###
    exportStructure: (ignoredFltrs = [], ignoredGrps = []) =>
        structure = []

        # loop over each group
        for g in @groups
            if ignoredGrps.indexOf(g.name) is -1
                group =
                    name: g.name,
                    display_name: g.display_name,
                    filters: []

                # loop over each filter in the group
                for f in g.filters
                    if ignoredFltrs.indexOf(f.name) is -1
                        # loop over each attribute in the filter
                        filter = []
                        for attr, value of f
                            filter[attr] = value

                        group.filters.push filter

                structure.push group

        return structure
